import React from "react";
import { AppColors } from "../assets/Colors";

const FourthTab = () => {
  return (
    // <div className="max-w-full mx-auto p-4 md:p-8 font-['Segoe UI']">
    <div className="max-w-9xl mx-auto px-6 py-12 bg-white rounded-2xl shadow-md flex flex-col lg:flex-row items-center lg:items-start gap-10">
      <div className="bg-white p-6 md:p-8 rounded-xl max-w-6xl mx-auto">
        {/* Heading */}
        <h2 className="text-2xl md:text-3xl font-semibold text-pink-600 text-center mb-4">
          Why Empfly Pulse is Needed
        </h2>
        <p className="text-center text-gray-700 mb-10 text-base md:text-lg">
          Every year, 1.5 lakh women in India are diagnosed with Breast Cancer.
        </p>

        {/* Card Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center items-stretch">
          {/* Box 1 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-green-100 flex flex-col h-full">
            <div className="relative w-24 h-24 mx-auto mb-4">
              <svg
                className="absolute top-0 left-0 w-full h-full text-green-200"
                viewBox="0 0 36 36"
              >
                <path
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  d="M18 2.0845
                     a 15.9155 15.9155 0 0 1 0 31.831
                     a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className="text-green-600"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  strokeDasharray="60, 100"
                  d="M18 2.0845
                     a 15.9155 15.9155 0 0 1 0 31.831
                     a 15.9155 15.9155 0 0 1 0 -31.831"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center text-xl font-bold text-green-700">
                60%
              </div>
            </div>
            <p
              className="mt-2 font-bold text-xl md:text-2xl flex-grow"
              style={{ color: AppColors.mainColor }}
            >
              Diagnosed at advanced stages,
              <br />
              leading to complex treatments & lower survival.
            </p>
          </div>

          {/* Box 2 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-pink-100 flex flex-col h-full">
            <div className="relative w-24 h-24 mx-auto mb-4">
              <svg
                className="absolute top-0 left-0 w-full h-full text-pink-200"
                viewBox="0 0 36 36"
              >
                <path
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  d="M18 2.0845
                     a 15.9155 15.9155 0 0 1 0 31.831
                     a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className="text-pink-500"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  strokeDasharray="80, 100"
                  d="M18 2.0845
                     a 15.9155 15.9155 0 0 1 0 31.831
                     a 15.9155 15.9155 0 0 1 0 -31.831"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center text-xl font-bold text-pink-600">
                80%
              </div>
            </div>
            <p
              className="mt-2 font-bold text-xl md:text-2xl flex-grow"
              style={{ color: AppColors.mainColor }}
            >
              Experience severe emotional distress after diagnosis.
            </p>
          </div>

          {/* Box 3 */}
          <div className="bg-white p-6 rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300 border border-green-100 flex flex-col h-full">
            <div className="relative w-24 h-24 mx-auto mb-4">
              <svg
                className="absolute top-0 left-0 w-full h-full text-green-200"
                viewBox="0 0 36 36"
              >
                <path
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  d="M18 2.0845
                     a 15.9155 15.9155 0 0 1 0 31.831
                     a 15.9155 15.9155 0 0 1 0 -31.831"
                />
                <path
                  className="text-green-700"
                  stroke="currentColor"
                  strokeWidth="4"
                  fill="none"
                  strokeDasharray="70, 100"
                  d="M18 2.0845
                     a 15.9155 15.9155 0 0 1 0 31.831
                     a 15.9155 15.9155 0 0 1 0 -31.831"
                />
              </svg>
              <div className="absolute inset-0 flex items-center justify-center text-xl font-bold text-green-800">
                70%
              </div>
            </div>
            <p
              className="mt-2 font-bold text-xl md:text-2xl flex-grow"
              style={{ color: AppColors.mainColor }}
            >
              Caregivers feel overwhelmed and unsupported.
            </p>
          </div>
        </div>

        {/* Footer Text */}
        <div className="text-center mt-10 text-green-700 font-medium text-base md:text-lg">
          Existing health apps lack compassion and true patient-centered design.{" "}
          <br />
          <span className="font-semibold text-green-900">
            Empfly Pulse changes this..
          </span>
        </div>
      </div>
    </div>
  );
};

export default FourthTab;
